import React from 'react'
import {
  Button,
  ButtonProps,
  Center,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  useMediaQuery,
  MenuOptionGroup
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { SearchInitialValues as InitialValues } from 'types'
import { LANGUAGES, LAST_SELECTED_FILTERS_STORAGE_KEY } from '../../constants'
import { useBrowserStorage } from 'hooks'

type LangSelectorProps = {} & ButtonProps

const LangSelector: React.FC<LangSelectorProps> = ({ children, ...rest }) => {
  const { i18n } = useTranslation()

  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  const [_localLastSelectedFilters, _setLocalLastSelectedFilters, removeLocalLastSelectedFilters] =
    useBrowserStorage<InitialValues & Pick<any, 'tab'>>(LAST_SELECTED_FILTERS_STORAGE_KEY, 'local')

  const removeFilters = () => {
    removeLocalLastSelectedFilters()
    window.location.reload()
  }
  return (
    <Menu closeOnSelect placement={isTabletOrMobile ? 'auto' : 'bottom-end'}>
      <MenuButton
        variant="ghost"
        size="sm"
        ml={2}
        as={Button}
        _hover={{ bg: 'transparent' }}
        _expanded={{ bg: 'transparent' }}
        _focus={{ boxShadow: 'outline' }}
        {...rest}
      >
        <Center>{children}</Center>
      </MenuButton>

      <MenuList py={0} rounded="xl" minWidth="120px">
        <MenuOptionGroup
          defaultValue={(i18n as any).language}
          onChange={(value) => {
            i18next.changeLanguage(value)
            removeFilters()
          }}
          type="radio"
        >
          {LANGUAGES.map((lang) => (
            <MenuItemOption fontSize="xs" fontWeight="bold" value={lang.code} key={lang.code}>
              {lang.name}
              {/* <span style={{ padding: '2rem' }}>{lang.icon}</span> */}
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  )
}

export default LangSelector
